<template>
    <div>
        <div v-if="design">
            <draggable class="l-drag-from" :list="dataColumns" group="componentsGroup">
                <draggable-item
                    v-for="(cp, index) in dataColumns"
                    :key="index"
                    :current-item="cp"
                    :drawing-list="dataColumns"
                    :index="index"
                    :in-table="true"
                    :selectItem="$attrs.selectItem"
                    @activeItem="activeItem"
                    @deleteItem="delItem"
                />
            </draggable>
            <div style="color: #c0bebe; text-align: center; width: 90%; padding: 5px">
                ☝ 拖拽控件到表格内部
            </div>
        </div>
        <el-table
            v-else
            size="medium"
            :header-cell-style="{ background: '#f5f7fa', padding: '3px 0' }"
            :border="true"
            :data="dataList"
            style="width: 100%"
        >
            <el-table-column fixed type="index" label="序号" width="50" />
            <el-table-column
                v-for="(column, index) in _columns"
                :key="index"
                :label="column.__config__.label"
            >
                <template slot-scope="{ $index }">
                    <render :info="dataList[$index]" :conf="column" @input="value => setValue(value, undefined, column, $index)" :option="option" />
                    <!-- <component :is="RenderCell(datas[$index][column.__vModel__], $index, buildListeners)" /> -->
                </template>
            </el-table-column>
            <el-table-column fixed="right" min-width="90" label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" :disabled="readonly" type="text" @click="delRow(scope.$index, scope.row)">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-button v-show="!design" size="small" icon="el-icon-plus" @click="addRow">添加数据</el-button>
    </div>
</template>
  
<script>
    import render from '@/render/render'
    import { copy } from '@/utils'
  
    export default {
        name: 'TableList',
        components: {
            render
        },
        props: {
            value: {
                type: Array,
                    default: () => {
                    return []
                },
            },
            columns: {
                type: Array,
                    default: () => {
                    return []
                },
            },
            maxSize: {
                type: Number,
                default: 0,
            },
            mode: {
                type: String,
                default: 'DESIGN',
            },
            _key: {
                type: String,
                default: '',
            },
            info: {
                type: Object,
                default: () => {}
            },
            readonly: {
                type: Boolean,
                default: false
            },
            option: {
                type: Object,
                default: () => {}
            }
        },
        // created () {
        //    this.init()
        // },
        watch: {
            value: {
                handler (val) {
                    this.dataList = copy(val)
                    this.init()
                },
                immediate: true,
            },
            dataList: {
                handler(val) {
                this.ivalue = val
                },
                immediate: true,
                deep: true,
            },
            dataColumns: {
                handler(value) {
                    const { eventHub, __vModel__ } = this.$attrs
                    console.log(this.$attrs, 'lyc')
                    eventHub.emit('designProps', { property: 'columns', data: value, key: __vModel__} )
                }
            },
            deep: true
        },
        computed: {
            _columns: {
                get () {
                return this.dataColumns
                },
                set (val) {
                this.dataColumns = val
                },
            },
        },
        data () {
            return {
                select: null,
                datas: [],
                dataList: [],
                ivalue: [],
                dataColumns: copy(this.columns),
                form: {},
                design: false,
            }
        },
        created() {
            const { componentToRegister, design } = this.$attrs
            if(design) {
                this.design = true
            }
            if(Array.isArray(componentToRegister)) {
                const [DraggableItem, draggable] = componentToRegister
                console.log(componentToRegister, componentToRegister.name)
                this.$options.components['draggable-item'] = DraggableItem
                this.$options.components['draggable'] = draggable
            }
        },
        methods: {
            init() {
                if (this.value.length) { // 表格数据回显
                    const cacheDatas = []
                    this.value.forEach(item => {
                        const rowData = {}
                        this.dataColumns.forEach((col) => {
                            const colObj = copy(col)
                            const key = col.__vModel__
                            colObj.__config__.defaultValue = item[key]
                            rowData[key] = colObj
                        })
                        cacheDatas.push(rowData)
                    })
                    this.datas = cacheDatas
                }
            },
            setValue (event, config, scheme, index) {
                console.log(event, config, scheme, index)
                // this.$set(config, 'defaultValue', event)
                this.$set(this.dataList[index], scheme.__vModel__, event)
                this.$emit("input", this.dataList)
            },
            buildListeners (scheme, index) {
                const config = scheme.__config__
                const listeners = {}
                listeners.input = event => this.setValue(event, config, scheme, index)
                return listeners
            },
            RenderCell: function (column, index, buildListeners) {
                const { option } = this.$attrs
                return {
                    render (h) {
                        const listeners = buildListeners(column, index)
                        return (
                            <render
                                conf={column}
                                info={{}}
                                {...{ on: listeners, attrs: {...this.$attrs, option} }}
                            />
                        )
                    }
                }
            },
            delRow (i, row) {
                this.dataList.splice(i, 1)
                this.datas.splice(i, 1)
                this.$emit("input", this.dataList)
            },
            addRow () {
                if (this.maxSize > 0 && this.ivalue.length >= this.maxSize) {
                    this.$message.warning(`最多只能添加${this.maxSize}行`)
                } else {
                    const row = {}
                    const rowData = {}
                    this.dataColumns.forEach((col) => {
                        this.$set(row, col.__vModel__, undefined)
                        rowData[col.__vModel__] = copy(col)
                    },
                    )
                    this.dataList.push(row)
                    this.$set(this, 'dataList', this.dataList)
                    this.datas.push(rowData)
                }
            },
            delItem (index) {
                this._columns.splice(index, 1)
            },
            activeItem(item) {
                const { eventHub } = this.$attrs
                eventHub.emit('activeItem', item )
            }
        },
    }
</script>
  
<style lang="less" scoped>
  /deep/ .valid-error {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }
  
  .choose {
    border: 1px dashed #1890ff !important;
  }
  
  .table-column {
    padding: 5px;
    margin-bottom: 10px;
    border-left: 3px solid #409eff;
    border-radius: 5px;
    background: #fafafa;
    /deep/ .el-form-item {
      margin-bottom: 0;
      .el-form-item__label {
        height: 25px;
      }
    }
    .table-column-action {
      float: right;
      span {
        color: #afafaf;
        margin-right: 10px;
        font-size: 13px;
      }
      i {
        color: #afafaf;
        padding: 5px;
        font-size: large;
        cursor: pointer;
        &:hover {
          color: #666666;
        }
      }
    }
  }
  </style>
  